import React from 'react';
import { Form, message } from 'antd';
import { Input, Button } from '@gamesb42/ui-kit';

interface LoginFormData {
  login: string;
  password: string;
}

interface LoginFormProps {
  loading: boolean;
  onFinish: (values: LoginFormData) => void;
  onSignupClick: () => void;
  onForgotPasswordClick?: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({
  loading,
  onFinish,
  onSignupClick,
  onForgotPasswordClick,
}) => {
  const [form] = Form.useForm();

  return (
    <>
      <h2
        style={{
          marginBottom: '20px',
          textAlign: 'left',
          color: '#090909',
          fontSize: '32px',
          fontWeight: 700,
          lineHeight: '40px',
          fontFamily: 'Muller',
        }}
      >
        Sign in and{' '}
        <span style={{ color: '#7145ec' }}>start earning revenue</span>
      </h2>

      <div style={{ marginBottom: '32px' }}>
        Don't have an account yet?{' '}
        <span
          style={{
            color: '#7145ec',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={onSignupClick}
        >
          Sign up
        </span>
      </div>

      <Form form={form} layout="vertical" onFinish={onFinish} size="large">
        <Form.Item
          name="login"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please enter a valid email!' },
          ]}
        >
          <Input label="Email" placeholder="Enter your email" size="large" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input
            label="Password"
            placeholder="Enter your password"
            size="large"
            type="password"
          />
        </Form.Item>

        {onForgotPasswordClick && (
          <div style={{ textAlign: 'right', marginBottom: '24px', marginTop: '-24px' }}>
            <span
              onClick={onForgotPasswordClick}
              style={{
                color: '#5227cb',
                fontSize: '16px',
                cursor: 'pointer',
                textDecoration: 'underline',
              }}
            >
              Forgot Password?
            </span>
          </div>
        )}

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
            violet
            style={{
              color: '#fff',
              width: '94px',
            }}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default LoginForm;
